import * as React from "react"

import { cn } from "@/lib/cn"

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex h-8 w-full rounded-[8px] border border-black/[0.08] bg-surface px-2.5 py-1 text-[12px] shadow-[inset_0_0.5px_1.5px_rgba(0,0,0,0.03)] transition-[box-shadow,border-color] duration-150 file:border-0 file:bg-transparent file:text-[12px] file:font-medium placeholder:text-subtle focus-visible:border-primary/50 focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-primary/15 disabled:cursor-not-allowed disabled:opacity-50",
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
